import Page from '../components/ui/Page';
import ContentLayout from '../layouts/ContentLayout';

const IndexPage = () => {
  return (
    <Page>
      <ContentLayout heading="Haaaalp!">
        <h4>Coming soon</h4>
      </ContentLayout>
    </Page>
  );
};

export default IndexPage;
